import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-start fw-bold pt-5 pb-4 border-0 border-3 border-bottom border-dark" }, " Donate Food Surplus ", -1)
const _hoisted_4 = {
  key: 0,
  class: "accordion accordion-flush border-0 border-2 border-bottom",
  id: "foodItems"
}
const _hoisted_5 = ["index"]
const _hoisted_6 = { class: "d-flex align-items-center py-3" }
const _hoisted_7 = ["data-bs-target", "aria-controls"]
const _hoisted_8 = { class: "d-flex flex-column text-start ps-1" }
const _hoisted_9 = { class: "fw-semibold m-0" }
const _hoisted_10 = { class: "text-muted" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("em", { class: "bi bi-trash3 h5" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["data-bs-target", "aria-controls"]
const _hoisted_15 = ["id"]
const _hoisted_16 = { class: "accordion-body" }
const _hoisted_17 = { class: "row my-3 text-start" }
const _hoisted_18 = { class: "col-12 col-sm-6 col-md-4 mt-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("small", { class: "fw-semibold" }, "Name", -1)
const _hoisted_20 = { class: "col-12 col-sm-6 col-md-4 mt-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("small", { class: "fw-semibold" }, "Food Item Type", -1)
const _hoisted_22 = { class: "col-12 col-sm-6 col-md-4 mt-2" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("small", { class: "fw-semibold" }, "Life Cycle Stage", -1)
const _hoisted_24 = { class: "col-12 col-sm-6 col-md-4 mt-2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("small", { class: "fw-semibold" }, "Quantity", -1)
const _hoisted_26 = { class: "col-12 col-md mt-2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("small", { class: "fw-semibold" }, "Weight (in kilograms)", -1)
const _hoisted_28 = {
  class: "accordion accordion-flush",
  id: "newFoodItem"
}
const _hoisted_29 = { class: "accordion-item mt-2 py-3" }
const _hoisted_30 = { class: "d-flex align-items-center" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn flex-fill ps-0 collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#itemForm",
  "aria-expanded": "true",
  "aria-controls": "itemForm"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column text-start ps-1" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "fw-semibold m-0" }, "New Food Item"),
    /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, "Add a food item to the donation list")
  ])
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("em", { class: "bi bi-plus-lg h5" }, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("button", {
  class: "accordion-button bg-transparent shadow-none w-auto collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#itemForm",
  "aria-expanded": "true",
  "aria-controls": "itemForm"
}, null, -1)
const _hoisted_35 = {
  id: "itemForm",
  class: "accordion-collapse collapse show",
  "data-bs-parent": "#newFoodItem"
}
const _hoisted_36 = { class: "accordion-body" }
const _hoisted_37 = { class: "row my-2 text-start" }
const _hoisted_38 = { class: "col-12 col-md-4 my-3" }
const _hoisted_39 = { class: "form-floating" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", {
  for: "itemName",
  class: "fw-medium text-black"
}, "Name", -1)
const _hoisted_41 = { class: "col-12 col-md-4 my-3" }
const _hoisted_42 = { class: "form-floating" }
const _hoisted_43 = ["value"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", {
  for: "itemType",
  class: "fw-medium text-black"
}, "Food Item Type", -1)
const _hoisted_45 = { class: "col-12 col-md-4 my-3" }
const _hoisted_46 = { class: "form-floating" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("option", { value: "In Storage" }, "In Storage", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("option", { value: "Prepared" }, "Prepared", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("option", { value: "Cooked" }, "Cooked", -1)
const _hoisted_50 = [
  _hoisted_47,
  _hoisted_48,
  _hoisted_49
]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", {
  for: "itemStage",
  class: "fw-medium text-black"
}, "Life Cycle Stage", -1)
const _hoisted_52 = { class: "col-12 col-md-6 my-3" }
const _hoisted_53 = { class: "form-floating" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", {
  for: "itemQuantity",
  class: "fw-medium text-black"
}, "Quantity", -1)
const _hoisted_55 = { class: "col-12 col-md-6 my-3" }
const _hoisted_56 = { class: "form-floating" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", {
  for: "itemWeight",
  class: "fw-medium text-black"
}, "Weight (in kilograms)", -1)
const _hoisted_58 = /*#__PURE__*/_createStaticVNode("<div class=\"accordion accordion-flush\" id=\"deliveryMethod\"><div class=\"accordion-item\"><div class=\"accordion-header\"><button class=\"accordion-button bg-transparent text-black ps-0\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#deliveryForm\" aria-expanded=\"true\" aria-controls=\"deliveryForm\"><div class=\"d-flex flex-column ps-1\"><h5 class=\"fw-semibold m-0\">Delivery Method</h5><small class=\"text-muted\">Change the delivery mode for your donation</small></div></button></div><div id=\"deliveryForm\" class=\"accordion-collapse collapse show\" data-bs-parent=\"#deliveryMethod\"><div class=\"accordion-body\"><div class=\"my-3\"><div class=\"form-floating\"><select class=\"form-select\" id=\"deliveryMode\" aria-label=\"Select delivery mode\"><option value=\"For Pickup\" selected>For Pick-up</option><option value=\"Hand Delivery\">Hand Delivery</option></select><label for=\"deliveryMode\" class=\"fw-medium text-black\">Delivery Mode</label></div></div><div class=\"mt-4 mb-3\"><div class=\"form-floating\"><textarea class=\"form-control\" placeholder=\"Write delivery details here\" id=\"deliveryNotes\" style=\"height:120px;\"></textarea><label for=\"itemType\" class=\"fw-medium text-black\">Delivery Notes</label></div></div></div></div></div></div><div class=\"accordion accordion-flush mt-2\" id=\"optionalNotes\"><div class=\"accordion-item\"><div class=\"accordion-header\"><button class=\"accordion-button bg-transparent text-black ps-0 collapsed\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#notesForm\" aria-expanded=\"false\" aria-controls=\"notesForm\"><div class=\"d-flex flex-column ps-1\"><h5 class=\"fw-semibold m-0\">Notes (Optional)</h5><small class=\"text-muted\">Leave a message if you&#39;d like...</small></div></button></div><div id=\"notesForm\" class=\"accordion-collapse collapse\" data-bs-parent=\"#deliveryMethod\"><div class=\"accordion-body\"><div class=\"my-3\"><div class=\"form-floating\"><textarea class=\"form-control\" placeholder=\"Write delivery details here\" id=\"deliveryNotes\" style=\"height:120px;\"></textarea><label for=\"itemType\" class=\"fw-medium text-black\">Optional Notes</label></div></div></div></div></div></div>", 2)
const _hoisted_60 = { class: "d-flex flex-column flex-md-row gap-3 justify-content-start my-5" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-secondary text-white rounded-0 flex-fill flex-md-grow-0 p-3",
  "data-bs-toggle": "modal",
  "data-bs-target": "#searchingForCharities"
}, " Open Donation ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchingFor = _resolveComponent("SearchingFor")!
  const _component_DonationQueue = _resolveComponent("DonationQueue")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (_ctx.foodItems.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.foodItems, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.itemId,
                  index: index,
                  class: "accordion-item food-item border-0"
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("button", {
                      class: "btn flex-fill ps-0 collapsed",
                      type: "button",
                      "data-bs-toggle": "collapse",
                      "data-bs-target": `#item-${index}`,
                      "aria-expanded": "false",
                      "aria-controls": `item-${index}`
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("h6", _hoisted_9, _toDisplayString(item.name), 1),
                        _createElementVNode("small", _hoisted_10, _toDisplayString(item.quantity * item.weight) + "kg • " + _toDisplayString(item.type), 1)
                      ])
                    ], 8, _hoisted_7),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn remove-item py-3",
                      onClick: ($event: any) => (_ctx.removeItem(index))
                    }, _hoisted_13, 8, _hoisted_11),
                    _createElementVNode("button", {
                      class: "accordion-button bg-transparent shadow-none w-auto collapsed",
                      type: "button",
                      "data-bs-toggle": "collapse",
                      "data-bs-target": `#item-${index}`,
                      "aria-expanded": "false",
                      "aria-controls": `item-${index}`
                    }, null, 8, _hoisted_14)
                  ]),
                  _createElementVNode("div", {
                    id: `item-${index}`,
                    class: "accordion-collapse collapse px-3",
                    "data-bs-parent": "#foodItems"
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _createElementVNode("p", null, _toDisplayString(item.name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _createElementVNode("p", null, _toDisplayString(item.type), 1)
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createElementVNode("p", null, _toDisplayString(item.stage), 1)
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _hoisted_25,
                          _createElementVNode("p", null, _toDisplayString(item.quantity) + " pc.", 1)
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _hoisted_27,
                          _createElementVNode("p", null, _toDisplayString(item.weight) + " kilograms", 1)
                        ])
                      ])
                    ])
                  ], 8, _hoisted_15)
                ], 8, _hoisted_5))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("button", {
                type: "button",
                class: "btn py-3",
                ref: "newItem",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createItem && _ctx.createItem(...args)))
              }, _hoisted_33, 512),
              _hoisted_34
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        placeholder: "Enter food item name here",
                        id: "itemName",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newItem.name) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.newItem.name]
                      ]),
                      _hoisted_40
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select",
                        id: "itemType",
                        "aria-label": "Select food item type",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newItem.type) = $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.foodTypes, (type) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: type,
                            value: type
                          }, _toDisplayString(type), 9, _hoisted_43))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.newItem.type]
                      ]),
                      _hoisted_44
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select",
                        id: "itemStage",
                        "aria-label": "Select life cycle stage",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newItem.stage) = $event))
                      }, _hoisted_50, 512), [
                        [_vModelSelect, _ctx.newItem.stage]
                      ]),
                      _hoisted_51
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "form-control",
                        placeholder: "Enter food item quantity here",
                        id: "itemQuantity",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newItem.quantity) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.newItem.quantity]
                      ]),
                      _hoisted_54
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "form-control",
                        placeholder: "Enter food item weight here",
                        id: "itemWeight",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newItem.weight) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.newItem.weight]
                      ]),
                      _hoisted_57
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _hoisted_58,
        _createElementVNode("div", _hoisted_60, [
          _hoisted_61,
          _createElementVNode("button", {
            type: "reset",
            class: "btn btn-outline-dark rounded-0 flex-fill flex-md-grow-0 p-3",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
          }, " Reset ")
        ])
      ])
    ]),
    _createVNode(_component_SearchingFor, {
      foundQueuers: _ctx.queuers.length > 0,
      windowWidth: _ctx.windowWidth
    }, null, 8, ["foundQueuers", "windowWidth"]),
    _createVNode(_component_DonationQueue, {
      queuers: _ctx.queuers,
      windowWidth: _ctx.windowWidth
    }, null, 8, ["queuers", "windowWidth"])
  ], 64))
}